import React, { Component } from 'react';
import UserService from '../services/users.js';
import NewPassword from '../components/users/newpassword';

import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Snackbar from '@material-ui/core/Snackbar';

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = { username: '', password: '', open: false ,showNewPassword:false};

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentDidMount() {
        UserService.validSecuritySession()
            .then(
                (result) => {
                    this.props.history.push('/workorders');
                }, (error) => {
                })
        this.props.handleMenu(
            {
                title: 'Inloggen',
                hide: true
            })
    }

    handleSubmit(event) {
        let self = this;

        if (this.state.username.length > 0 && this.state.password.length > 0) {

            UserService.authenticate(this.state.username, this.state.password)
                .then(result => {
                    this.props.history.push('/workorders');
                }, error => {
                    self.setState({ open: true });
                });
        } else {
            self.setState({ open: true });
        }

        event.preventDefault();
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
            [name]: value
        });
    }

    handleClose = () => {
        this.setState({ open: false });
    };

    render() {
        const styleCard = { margin: '0 auto', marginTop: '20px', maxWidth: '500px', width: '100%' }
        const styleBanner = { height: '200px', backgroundImage: 'url(images/welding.png) ', backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }

        return (
            <div>
                {this.state.showNewPassword && <NewPassword handleClose={()=>{this.setState({showNewPassword:false})}} {...this.props}/>}
                <Card style={styleCard} >

                    <div style={styleBanner} ></div>
                    <div style={{ padding: '20px' }}>
                        Inloggen Werkbon App
                    <br />
                        <br />
                        <form onSubmit={this.handleSubmit}>
                            <TextField label='E-mailadres' style={{ width: '100%', backgroundColor: 'white' }}
                                value={this.state.username}
                                onChange={(e) => this.setState({ username: e.target.value })}
                            />
                            <br /><br />
                            <TextField label='wachtwoord' style={{ width: '100%', backgroundColor: 'white' }}
                                type='password'
                                value={this.state.password}
                                onChange={(e) => this.setState({ password: e.target.value })}
                            />
                        </form>

                    </div>
                    <CardActions>
                        <Button style={{ width: '100%' }} variant="contained" color="primary" onClick={this.handleSubmit}>
                            Inloggen
                    </Button>

                    </CardActions>
                    <br />
                    <Button  onClick={() => this.setState({showNewPassword:true})} style={{ width: '100%' }}>(Nieuw) wachtwoord aanmaken</Button>
                    <br />
                    <Button onClick={() => this.props.history.push('/privacy')} style={{ width: '100%' }}>Lees hier onze privacyverklaring</Button>
                    <br />
                    <Button onClick={() => this.props.history.push('/info')} style={{ width: '100%' }}>Over deze App</Button>
                </Card>
                <Snackbar
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    open={this.state.open}
                    autoHideDuration={4000}
                    onClose={this.handleClose}
                    ContentProps={{
                        'aria-describedby': 'message-id',
                    }}
                    message={<span id="message-id">Het inloggen is mislukt, controleer je accountnaam en/of wachtwoord</span>}
                />
            </div>
        );
    }
}

export default Login;
